import { ReactElement } from "react";
import { Link } from "react-router-dom";
import { IComponent } from "../../../../../services/http/component/models/IComponent";
import { IBranch } from "../../../../../services/http/component/models/IBranch";
import StatusIndicator from "../../../../Shared/StatusIndicator";
import { className } from "../../../../../shared/helpers";
import styles from "./SearchResult.module.scss";

interface ISearchResultProps
{
    text: string;
    components: IComponent[];
    getBranches: (x: number) => IBranch[];
    onSelected: () => void;
}

const SearchResult = (props: ISearchResultProps): ReactElement =>
{
    const noResults = props.components.length === 0;

    const highlightText = (text: string): string =>
    {
        if (!props.text || props.text.length < 1)
            return text;

        const regExp = new RegExp(props.text, "ig");
        const match = text.match(regExp);

        if (!match)
        {
            return text;
        }

        for (var i = 0; i < match.length; i++)
        {
            if (props.text !== ".")
            {
                text = text.replace(regExp, `<b>${match[i]}</b>`);
            }
        }
        return text;
    };

    const getBreadcrumb = (branchId: number): string =>
    {
        const components: string[] = [];
        const branchesList = props.getBranches(branchId).filter(x => x.level > 1)
            .sort((a, b) => a.level > b.level ? 1 : -1)
            .map(x => x);

        for (const branch of branchesList)
            components.push(branch.componentName);

        return components.join(" › ");
    }

    return (
        <ul {...className(styles.results, { [styles.noResults]: noResults })}>
            {props.components.length > 0 && props.components.map(x => (
                <li key={x.id}>
                    <Link to={`/dashboard/${x.id}`} onClick={props.onSelected}>
                        <StatusIndicator customClassName={styles.status} component={x} />

                        <div className={styles.component}>
                            <div className={styles.details}>
                                <span dangerouslySetInnerHTML={{ __html: highlightText(getBreadcrumb(x.branchId)) }} />
                            </div>

                            <span dangerouslySetInnerHTML={{ __html: highlightText(x.name) }} />
                        </div>
                    </Link>
                </li>
            ))}

            {noResults && <li>No results found...</li>}
        </ul>
    );
};

export default SearchResult;
